export default "__VITE_ASSET__C8I9PN7x__"